import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@common/store/hooks";
import { logout, redirectToLogin, validateToken } from "@common/store/slices/authSlice";
import { LS_KEYS } from "@common/constants";
import MaterialIcon from "@common/components/MaterialIcon";

export default function AuthMenu() {
  const dispatch = useAppDispatch();
  const { isAuthenticated, userEmail, userName, isLoading } = useAppSelector((s) => s.auth);

  useEffect(() => {
    if (localStorage.getItem(LS_KEYS.accessToken)) dispatch(validateToken());
  }, [dispatch]);

  if (isLoading) return <span className="muted">Checking sign-in…</span>;

  if (isAuthenticated) {
    return (
      <div className="auth">
        <Link
          to="/profile"
          className="btn icon-btn auth-me"
          aria-label="Your profile"
          data-tip={`${userName ?? userEmail ?? "You"} · your profile`}
        >
          <MaterialIcon name="account_circle" />
        </Link>
        <button type="button" className="btn icon-btn" aria-label="Sign out" data-tip="Sign out" onClick={() => dispatch(logout())}>
          <MaterialIcon name="logout" />
        </button>
      </div>
    );
  }

  return (
    <button type="button" className="btn" onClick={() => dispatch(redirectToLogin())}>
      Sign in
    </button>
  );
}
